import { ww } from '../partials/windowWidth';

/**
 * Init function called in master script
 * 
 */
export function footer () {

    const config = { 
        breakpoint: '768',
        classes: {
            hideUtlities: ['overflow-hidden', 'max-h-0'],
            showUtilities: ['overflow-auto', 'max-h-none']
        }
    }

    window.onload = checkWindowWidth;
    window.onresize = checkWindowWidth;

    /**
     * Listen to clicks on menu headers
     * Mobile only
     * 
     */
    const footerMenuToggles = document.querySelectorAll('.footer-menus [data-action="menu-toggle"]');

    footerMenuToggles.forEach( element => {
        element.addEventListener('click', e => {
            if( ww.getWindowWidth() < config.breakpoint ) {
                const list = e.target.nodeName == 'svg' ? e.target.parentElement.nextElementSibling : e.target.nextElementSibling;
                const isVisible = list.getAttribute('data-visible');


                if( isVisible == 'true' ) {
                    hideMenu(list);
                } else {
                    showMenu(list);
                }
            }
        })
    })

    /**
     * Checks window size against configuration breakpoint
     * hides and shows menu accordingly
     * 
     */
    function checkWindowWidth() {
        if( ww.getWindowWidth() < config.breakpoint ) {
            // hide the footer menus
            footerMenusSetVisibility( 'hide' );
        } else {
            // show the footer menus
            footerMenusSetVisibility( 'show' );
        }
    }

    /**
     * Hide and show all footer menus depending on visibility param
     * 
     * @param {string} visibility : ;
     * 
     */
    function footerMenusSetVisibility( visibility ) {
        const footerMenus = document.querySelectorAll('.footer-menus ul');

        footerMenus.forEach( menu => {

            if( visibility === 'show' ) {
                showMenu(menu);
            } else if ( visibility === 'hide' ) {
                hideMenu(menu);
            }

        });

    }

    /**
     * Shows a given menu
     * 
     * @param {*} menu 
     * 
     */
    function showMenu(menu) {
        const hide = [...config.classes.hideUtlities];
        const show = [...config.classes.showUtilities];
        
        menu.classList.remove(...hide);
        menu.classList.add(...show);
        menu.setAttribute('data-visible', true);
    }
    
    /**
     * Hides a given menu
     * 
     * @param {*} menu 
     * 
     */
    function hideMenu(menu) {
        const hide = [...config.classes.hideUtlities];
        const show = [...config.classes.showUtilities];

        menu.classList.remove(...show);
        menu.classList.add(...hide);
        menu.setAttribute('data-visible', false);
    }

};

